import React, { useContext, useEffect, useState, useRef } from 'react';
import MultiSelectEntity from '../RefineSearch/TgMultiSelectEntity';
import FilterWrapper from './FilterWrapper';
import { PeFilterContext } from '../../Contexts/PeFilterContext';

function AcquirerGroup({ open, accordionClick, acquirerGroupOptions, setAcquirerGroupOptions, label, filterGroupUrl, customPathname }) {

  const { acquirerGroup, setAcquirerGroup, refineSearchFilters } = useContext(PeFilterContext);
  const [companyVal, setCompanyVal] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [fetchedData, setFetchedData] = useState([]);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (companyVal.trim() !== "") {
        // Filter acquirerGroup based on search
        const filtered = acquirerGroupOptions.filter(option => 
          option.name.toLowerCase().includes(companyVal.toLowerCase())
        );
        setFetchedData(filtered);
        setShowDropdown(true);
      } else if (isFocused) {
        // Show selected items when focused but no search text
        const selectedItems = acquirerGroupOptions.filter(option => option.isChecked);
        if (selectedItems.length > 0) {
          setFetchedData(selectedItems);
          setShowDropdown(true);
        } else {
          setShowDropdown(false);
          setFetchedData([]);
        }
      } else {
        setShowDropdown(false);
        setFetchedData([]);
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [companyVal, acquirerGroupOptions, isFocused]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
        inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleGroupChange = (e) => {
    const { checked, id, name } = e.target;
    const updatedOptions = acquirerGroupOptions.map(option => {
        return option.name === name ? { ...option, isChecked: checked } : option;
    });
    setAcquirerGroup(updatedOptions);
    setAcquirerGroupOptions(updatedOptions);
  };

  const count = acquirerGroup?.filter((option) => option.isChecked).length || 0;
  const hasValue = companyVal || count > 0;

  return (
    <div className="relative">
      {/* Dropdown - Positioned BELOW the input */}
      {showDropdown && fetchedData.length > 0 && (
        <div ref={dropdownRef} className="absolute z-50 w-full top-full mt-1 bg-white border border-gray-100 rounded-lg shadow-sm max-h-64 overflow-y-auto">
          <MultiSelectEntity
            handleEntityChange={handleGroupChange}
            primaryEntity={fetchedData}
            setCompanyVal={setCompanyVal}
            customPathname={customPathname}
            city="city"
            showAll={false}
          />
        </div>
      )}

      <div className={`absolute left-3 transition-all duration-200 pointer-events-none flex items-center gap-2 z-10 ${isFocused || hasValue
          ? 'top-0 -translate-y-1/2 text-xs bg-white px-1 text-[#BC8B20]'
          : 'top-1/2 -translate-y-1/2 text-sm text-gray-500'
        }`}>
        <span>{label}</span>
        {(isFocused || hasValue) && count > 0 && (
          <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
            {count}
          </span>
        )}
      </div>

      <input
        ref={inputRef}
        type="text"
        value={companyVal}
        onChange={(e) => setCompanyVal(e.target.value)}
        onFocus={() => {
          setIsFocused(true);
          if (companyVal.trim() !== "") {
            setShowDropdown(true);
          } else {
            // Show selected items when focused but no search text
            const selectedItems = acquirerGroupOptions.filter(option => option.isChecked);
            if (selectedItems.length > 0) {
              setFetchedData(selectedItems);
              setShowDropdown(true);
            }
          }
        }}
        onBlur={() => {
          setTimeout(() => setIsFocused(false), 200);
        }}
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
        placeholder=""
      />
    </div>
  );
}

export default AcquirerGroup;
